var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVMboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-VMbox_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VMbox_Active",
    clipPath: "url(#clip-VMbox_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voicemail_Box",
    "data-name": "Voicemail Box",
    transform: "translate(1.001 2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_34",
    "data-name": "Subtraction 34",
    d: "M-568.746-542.184a.575.575,0,0,1-.317-.1l-6.684-3.912h-11.991A3.266,3.266,0,0,1-591-549.455V-564a3.266,3.266,0,0,1,3.263-3.263h8.506a.634.634,0,0,1,.634.634.421.421,0,0,1,0,.047h1.087a.649.649,0,0,1,.648-.648h.876a.649.649,0,0,1,.648.648h1.037v-.031a.634.634,0,0,1,.634-.634h9.409A3.266,3.266,0,0,1-561-563.98v14.54a3.267,3.267,0,0,1-3.263,3.263h-3.849v3.358a.661.661,0,0,1-.317.554A.551.551,0,0,1-568.746-542.184Zm-1.819-10.335h0c.08,0,.161.007.239.007a4.381,4.381,0,0,0,4.376-4.377,4.381,4.381,0,0,0-4.376-4.376,4.381,4.381,0,0,0-4.377,4.376,4.348,4.348,0,0,0,1.27,3.08h-5.133a4.347,4.347,0,0,0,1.269-3.079,4.381,4.381,0,0,0-4.376-4.377,4.382,4.382,0,0,0-4.377,4.377,4.381,4.381,0,0,0,4.377,4.376h11.022a.651.651,0,0,0,.085-.006Zm.239-1.29a3.083,3.083,0,0,1-3.08-3.08,3.083,3.083,0,0,1,3.08-3.08,3.083,3.083,0,0,1,3.08,3.08A3.083,3.083,0,0,1-570.326-553.81Zm-11.346,0a3.083,3.083,0,0,1-3.08-3.079,3.083,3.083,0,0,1,3.08-3.08,3.083,3.083,0,0,1,3.079,3.08A3.082,3.082,0,0,1-581.673-553.81Z",
    transform: "translate(590.999 567.259)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVMboxActive);
export default __webpack_public_path__ + "static/media/VMbox_Active.e456948e95728b58f46054190dc8d9d4.svg";
export { ForwardRef as ReactComponent };